import { render, staticRenderFns } from "./independentNumber.vue?vue&type=template&id=0cd34b9d&scoped=true&"
import script from "./independentNumber.vue?vue&type=script&lang=js&"
export * from "./independentNumber.vue?vue&type=script&lang=js&"
import style0 from "./independentNumber.vue?vue&type=style&index=0&id=0cd34b9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd34b9d",
  null
  
)

export default component.exports